import { RoleConfig } from '../types/tenant';
import { isLimitedRoleConfig } from './metricUtils';


// get font size for role config in player tables
export const getRoleConfigTableFontSize = (
  roleConfig: RoleConfig,
  defaultFontSize?: number,
) => {
  const fontSize = defaultFontSize ?? 13;

  const isLimited = isLimitedRoleConfig(roleConfig);
  let widthScore = isLimited ? 2 : 0;

  const nameLength = roleConfig.name.length;
  const capitalLetters = (roleConfig.name.match(/[A-Z]/g) || []).length;

  widthScore += nameLength;
  widthScore += capitalLetters * 0.25;

  if (widthScore > 20) return fontSize - 5;
  if (widthScore > 19) return fontSize - 4;
  if (widthScore > 18) return fontSize - 3;
  if (widthScore > 17) return fontSize - 2;
  if (widthScore > 16) return fontSize - 1;

  return fontSize;
};


// get font size for role config in player statistics view
export const getRoleConfigPlayerViewFontSize = (
  name: string,
  isLimitedRoleConfig: boolean,
  numberOfRoleIndexes: number
) => {
  const defaultFontSize = 11;

  let nameLengthScore = name.length;
  nameLengthScore += (numberOfRoleIndexes * 2);

  const capitalLetters = (name.match(/[A-Z]/g) || []).length;
  nameLengthScore += (capitalLetters * 0.25);

  if (isLimitedRoleConfig) nameLengthScore += 2;

  if (nameLengthScore > 24) return defaultFontSize - 2;
  if (nameLengthScore > 22) return defaultFontSize - 1;
  return defaultFontSize;
};
